var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsDynamoDb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_128)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_128)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 76H180V176H80V76Z",
    fill: "url(#paint0_linear_1_128)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.165 153.547V146.382C141.35 149.652 133.43 151.807 123.82 151.807C114.202 151.807 106.283 149.65 102.468 146.377V153.535C102.468 157.062 111.238 160.995 123.818 160.995C136.385 160.995 145.145 157.07 145.167 153.545L145.165 153.547ZM145.167 133.11L147.635 133.095V133.11C147.635 134.672 146.855 136.128 145.37 137.465C147.185 139.098 147.635 140.7 147.635 141.84L147.632 141.86V153.535C147.632 159.215 137.398 163.5 123.82 163.5C110.312 163.5 100.12 159.26 100.013 153.622C100.013 153.597 100 153.583 100 153.56V141.835L100.005 141.815C100.01 140.68 100.463 139.09 102.255 137.473C100.465 135.848 100.013 134.262 100.003 133.137L100 133.125V121.4L100.005 121.382C100.01 120.245 100.465 118.658 102.26 117.038C100.465 115.413 100.01 113.83 100.003 112.702L100 112.688V100.962C100 100.947 100.008 100.94 100.008 100.927C100.058 95.265 110.272 91 123.82 91C130.34 91 136.605 92.075 141.005 93.9425L140.052 96.255C135.945 94.505 130.027 93.505 123.82 93.505C111.237 93.505 102.47 97.4375 102.47 100.965C102.47 104.498 111.237 108.43 123.82 108.43C124.165 108.433 124.49 108.43 124.827 108.415L124.928 110.915C124.558 110.935 124.187 110.935 123.82 110.935C114.202 110.935 106.283 108.778 102.468 105.505V112.69C102.483 114.052 103.825 115.24 104.948 115.995C108.318 118.22 114.355 119.735 121.083 120.05L120.965 122.55C114.157 122.235 108.19 120.77 104.353 118.53C103.393 119.267 102.47 120.26 102.47 121.405C102.47 124.933 111.237 128.865 123.82 128.865C125.06 128.865 126.27 128.823 127.453 128.74L127.632 131.235C126.392 131.325 125.117 131.37 123.82 131.37C114.202 131.37 106.283 129.215 102.468 125.942V133.095C102.483 134.49 103.823 135.678 104.948 136.43C108.798 138.975 116.032 140.555 123.82 140.555H124.367V143.063H123.818C115.905 143.063 108.745 141.533 104.355 138.96C103.395 139.698 102.47 140.693 102.47 141.84C102.47 145.368 111.237 149.3 123.82 149.3C136.38 149.3 145.137 145.382 145.165 141.855V141.833C145.165 140.695 144.247 139.707 143.292 138.97C142.685 139.327 142.03 139.67 141.29 139.985L140.335 137.68C141.24 137.29 142.03 136.873 142.682 136.43C143.815 135.665 145.167 134.465 145.167 133.11ZM158.387 112.223H150.18C149.983 112.221 149.79 112.173 149.616 112.082C149.442 111.99 149.292 111.859 149.18 111.698C149.065 111.535 148.991 111.349 148.961 111.152C148.932 110.956 148.95 110.756 149.012 110.567L152.65 99.6975H136.33L128.527 114.728H136.45C136.64 114.728 136.828 114.772 136.998 114.858C137.168 114.943 137.316 115.067 137.43 115.22C137.546 115.374 137.625 115.552 137.661 115.741C137.698 115.93 137.69 116.124 137.64 116.31L130.845 141.58L158.387 112.223ZM162.163 111.835L129.262 146.9C129.073 147.099 128.823 147.23 128.551 147.271C128.279 147.311 128.002 147.26 127.762 147.125C127.523 146.985 127.336 146.77 127.231 146.514C127.125 146.257 127.108 145.973 127.18 145.705L134.837 117.23H126.483C126.269 117.23 126.059 117.174 125.874 117.068C125.688 116.962 125.534 116.809 125.425 116.625C125.315 116.44 125.254 116.23 125.248 116.015C125.241 115.799 125.29 115.586 125.39 115.395L134.495 97.8625C134.598 97.6622 134.755 97.4941 134.947 97.3764C135.139 97.2587 135.36 97.196 135.585 97.195H154.373C154.773 97.195 155.145 97.39 155.375 97.7175C155.489 97.8804 155.563 98.0676 155.592 98.2642C155.62 98.4608 155.603 98.6614 155.54 98.85L151.902 109.718H161.267C161.762 109.718 162.207 110.018 162.402 110.478C162.497 110.703 162.524 110.951 162.482 111.191C162.439 111.432 162.328 111.656 162.163 111.835ZM104.32 153.6C105.747 154.43 107.495 155.165 109.518 155.775L110.22 153.375C108.385 152.82 106.812 152.165 105.547 151.427L104.32 153.6ZM109.518 135.52L110.22 133.12C108.39 132.567 106.82 131.91 105.547 131.17L104.32 133.345C105.752 134.18 107.503 134.913 109.518 135.52ZM104.318 113.085L105.547 110.915C106.81 111.65 108.385 112.31 110.222 112.865L109.518 115.265C107.493 114.655 105.748 113.92 104.318 113.085Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_128",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_128",
    x1: 80,
    y1: 10076,
    x2: 10080,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(80 76)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsDynamoDb);
export default __webpack_public_path__ + "static/media/aws-dynamo-db.577cb1fe414bcf721bc6939b7e41ff28.svg";
export { ForwardRef as ReactComponent };